import Api from "@src/api";
export const FacilityMasterApi= {
  getList(params) {
    return Api().get("FacilityNew/SearchNewFacility",{params});
  },
  getFacilityNewById(id) {
    return Api().get("FacilityNew/" + id);
  },
  updateFacilityNew(data) {
    return Api().put("FacilityNew", data);
  },
  
  updatefacilitymaster(data){
    return Api().put("/FacilityNew/UpdateFacilityMaster", data);
  },
  createFacilityNew(data) {
    return Api().post("FacilityNew", data);
  },
  deleteFacilityNew(id) {
    return Api().delete("FacilityNew/DeleteFacility?facilityCode=" + id);
  },

  // Plan Facility
  getDetailPlan(id){
    return Api().get("FacilityPlannedValueInfo/" + id)
  },
  getListPlan(params){
    return Api().get("FacilityPlannedValueInfo/entity",{
      params
    })
  },
  addPlan(data){
    return Api().post("FacilityPlannedValueInfo",data)
  },
  updatePlan(data){
    return Api().put("FacilityPlannedValueInfo",data)
  },
  deletePlan(params){
    return Api().delete("FacilityPlannedValueInfo?" + params)
}
}
